import type { Components } from '@mildang/mui';
import type { Theme } from '@mildang/mui';

const createDivider = (theme: Theme): Components => ({
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: 'rgba(0, 0, 0, 0.08)',
      },
    },
  },
});

export default createDivider;
